import { onMounted, onUnmounted } from 'vue';
import { useUtilsStore } from '@/stores/utils';

export const useScreenTracker = () => {
  const utilsStore = useUtilsStore();

  const handleResize = () => {
    utilsStore.updateScreenSize();
  };

  onMounted(() => {
    // 初期値を設定
    handleResize();
    window.addEventListener('resize', handleResize);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
  });

  // 必要であれば、ストアのプロパティを返すこともできます
};
